import {AnalyticEventDTO, AnalyticEventEnum} from 'grilnica-store-share'
import {getRoistatVisit} from '../../roistat'
import {CONSTANTS} from '../../../../constants'
import {apiPost} from 'grilnica-share-client'

function roistatEvent(eventId: AnalyticEventEnum, data?: object): void {
  const event: AnalyticEventDTO = {
    eventId,
    roistatVisit: getRoistatVisit(),
    data,
  }
  apiPost(CONSTANTS.apiStoreUrl + '/analytic/event', event)
}

function addProductRoistatEvent(): void {
  const location = getLocation()
  roistatEvent(AnalyticEventEnum.ADD_PRODUCT_TO_BASKET, location ? {location} : undefined)
}

function getLocation(): string | undefined {
  const pathname = window.location?.pathname
  if (!pathname) {
    return
  } else if (pathname.startsWith('/menu')) {
    return 'Меню'
  } else if (pathname.startsWith('/actions')) {
    return 'Акции'
  } else if (pathname.startsWith('/notifications')) {
    return 'Уведомления'
  } else {
    return pathname
  }
}

export {roistatEvent, addProductRoistatEvent}
